import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { PricingTableWithFetch } from "./pricing-table-with-fetch.tsx";
import { PricingTableWithoutFetch } from "./pricing-table-without-fetch.tsx";
import { ContentfulFeature, PlanTitle } from "./types.ts";

export interface UniformPricingTableProps {
    urlSlug: string;
    componentLocale?: string;
    tableData?: ContentfulFeature[];
    planTitles?: PlanTitle[];
}

const UniformPricingTable = (props: UniformPricingTableProps) => {
    const { urlSlug, componentLocale } = props;

    const waePricingGqlEnabled = checkFeatureFlagGate(
        featureFlags.waePricingGql
    );

    if (urlSlug && componentLocale && waePricingGqlEnabled) {
        return (
            <PricingTableWithFetch urlSlug={urlSlug} locale={componentLocale} />
        );
    }

    const { tableData, planTitles } = props;

    if (tableData && planTitles) {
        return (
            <PricingTableWithoutFetch
                urlSlug={urlSlug}
                tableData={tableData}
                planTitles={planTitles}
            />
        );
    }

    return null;
};

export default UniformPricingTable;
